import { render, staticRenderFns } from "./Otpoints.vue?vue&type=template&id=6fabc462&scoped=true&"
import script from "./Otpoints.vue?vue&type=script&lang=js&"
export * from "./Otpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabc462",
  null
  
)

export default component.exports